import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';

export type TokenPair = components['schemas']['TokenPair'];
export type MePayload = components['schemas']['MePayload'];
export type LoginRequest = components['schemas']['LoginRequest'];
export type RefreshRequest = components['schemas']['RefreshRequest'];
export type MessageResponse = components['schemas']['MessageResponse'];
export type LeddoStartResponse = components['schemas']['LeddoStartResponse'];

export async function loginRequest(payload: LoginRequest): Promise<TokenPair> {
  const response = await httpClient.post<TokenPair>('/api/v1/auth/login', payload);
  return response.data;
}

export async function refreshRequest(payload: RefreshRequest): Promise<TokenPair> {
  const response = await httpClient.post<TokenPair>('/api/v1/auth/refresh', payload);
  return response.data;
}

export async function logoutRequest(): Promise<MessageResponse> {
  const response = await httpClient.post<MessageResponse>('/api/v1/auth/logout');
  return response.data;
}

export async function meRequest(): Promise<MePayload> {
  const response = await httpClient.get<MePayload>('/api/v1/auth/me');
  return response.data;
}

/**
 * Inicia o fluxo OAuth com o Leddo para o cliente web.
 *
 * `subdomain` (leddo-universal v2, Task 14) desambigua tenants multi-org:
 * omitido continua funcionando para single-org.
 */
export async function leddoStart(subdomain?: string): Promise<LeddoStartResponse> {
  const response = await httpClient.get<LeddoStartResponse>('/api/v1/auth/leddo/start', {
    params: { client: 'web', ...(subdomain ? { subdomain } : {}) },
  });
  return response.data;
}

/** Troca o code + state pelo par de tokens após o redirect do Leddo. */
export async function leddoCallback(code: string, state: string): Promise<TokenPair> {
  const response = await httpClient.get<TokenPair>('/api/v1/auth/leddo/callback', {
    params: { code, state },
  });
  return response.data;
}
